import script from "./AdminAccount.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminAccount.vue?vue&type=script&setup=true&lang=js"

import "@/assets/styles/sfc/components/sites/AdminAccount.css?vue&type=style&index=0&id=e4cf4056&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e4cf4056"]])

export default __exports__